import { attachSliderBehavior, getSliderElements } from "./sliderCore";

export const initMegaMenuThemenweltenSlider = (root: ParentNode = document): void => {
  const sliders = root.querySelectorAll<HTMLElement>("[data-mega-menu-themenwelten-slider]");

  for (const sectionEl of sliders) {
    if (sectionEl.dataset.sliderInit === "true") continue;

    const sectionId = sectionEl.dataset.sliderId;
    if (!sectionId) continue;

    const elements = getSliderElements(sectionEl, sectionId);
    if (!elements) continue;

    sectionEl.dataset.sliderInit = "true";
    attachSliderBehavior(elements, sectionId);
  }
};
